
var tryNowCart = {};
var tryNowCartMax = 0; // Change in theme settings if needed
var tryNowTotal = 0; // price of all trynow items (not price without them)
var tryNowItemCount = 0; // used for cart max if needed
var shopName = 'implementationinterview'; // This might not be effective depending on the name of the shopName in the shops table
var tryNowShopUrl = "https://" + shopName + ".trynowcheckout.com/customer-information?shopName=" + shopName + "&token=";
var tryNowSelectors = {
    // Update these with current selectors
    ajaxCartMeta: '.ajaxcart__product-meta', // Will show up as TryNow: true
    ajaxCartParent: '.ajaxcart__row', // Row of the line item in the cart, container needs to wrap both the price and the cart meta
    ajaxCartPrice: '.ajaxcart__price', // class of element where price is displayed
    ajaxCartTotal: '.one-third .ajaxcart__subtotal',
    ajaxCartQtyInput: '.ajaxcart__qty-num',
    ajaxCartQtyPlus: '.ajaxcart__qty--plus',
    ajaxCartQtyMinus: '.ajaxcart__qty--minus',
    ajaxCartQtyTryNowPlus: '.js-qty__adjust--plus.trynow',
    ajaxCartQtyMinus: '.js-qty__wrapper input',
    checkoutBtn: 'button[name="checkout"]',
    
    // No change needed
    tryNowBuy: '.TryNowBuy',
    tryNowCartMaxMessage: '.trynow-cart-max-message',
    tryNowCheckoutButton: '#trynow-checkout-btn',
    tryNowHoldDisclaimer: '.hold-disclaimer',
    tryNowInput: '#TryNowInput',
    tryNowLearnMore: '#trynow-learn-more-id',
    tryNowLoyaltyDisclaimer: '.loyalty-disclaimer',
    tryNowSubtotal: '.trynow-subtotal-kept',
    tryNowTrial: '#TryNowTrial', 
    tryNowTryAtHomeLabel: '.try-at-home-label-ajax',

    //Roolee selectors
    cartTotalSelector: '#cart-price',
    cartCountSelector: '.cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count',
};
var tryNowCount = function(cart) {
    var count = 0;
    for (item of cart.items) {
        if(item.properties &&  item.properties.tn_enabled == "true") {
            count += item.quantity;
        }
    }
    return count;
};
var tryNowPrice = function(cart){
    var price = 0;
    for (item of cart.items) {
        if(item.properties && item.properties.tn_enabled == "true") {
            price += item.final_line_price;
        }
    }
    return price;
};
var convertCurrency = function(amount) {
    var amount = amount;
    if (amount > 9) {
        amount += '';
        amount = amount.substr(0, amount.length - 2) + '.' + amount.substr(amount.length - 2);
    }
    return '$' + amount;
};
var tryNowPriceDisplay = function(tryNowAmount, totalAmount) {
    if(tryNowAmount == totalAmount) {
        return convertCurrency(totalAmount)
    } else {
        return convertCurrency(tryNowAmount) + " (" + convertCurrency(totalAmount) + " if kept)"
    }
}

var updateAjaxCart = function(cart) {
    console.log(cart);
    tryNowCart = cart;
    tryNowItemCount = tryNowCount(cart);
    tryNowTotal = tryNowPrice(cart);

    $(tryNowSelectors.tryNowInput).attr('name', "properties[tn_enabled]");
    $(tryNowSelectors.ajaxCartQtyPlus).removeClass('trynow');

    

    if(tryNowCart) {
        $(tryNowSelectors.tryNowCheckoutButton).attr("href", tryNowShopUrl + tryNowCart.token);
    }

    // update line items appearance
    $(tryNowSelectors.ajaxCartMeta).each(function (e) {
        var obj = $(this).text().trim().split(":");

        // check for property TryNow = true
        if (obj[0].trim() == 'TryNow') {
            $(this).hide();
        }

        if (obj[0].trim() == 'TryNow' && obj[1].trim() == 'true') {            
            var $product = $(this).parents(tryNowSelectors.ajaxCartParent);
            var $price = $product.find(tryNowSelectors.ajaxCartPrice)
            var amount = $price.text().trim();

            // change price to show TryNow Price
            if(!amount.includes("if kept")) {
                $price.html('<span class="trynow-price">$0</span><br><span class="trynow-price-kept">' + amount + ' if kept</span>');
            }

            if (!$product.find(tryNowSelectors.tryNowTryAtHomeLabel).length) {
                $product.find(tryNowSelectors.ajaxCartItemName).before('<span class="try-at-home-label-ajax">Try At Home</span>');
            }

            $product.find(tryNowSelectors.ajaxCartQtyPlus).addClass('trynow');
        }
    });
    
    // TryNow Subtotal
    $(tryNowSelectors.ajaxCartTotal).html('<span class="trynow-subtotal">' + convertCurrency(cart.total_price - tryNowTotal) + '</span><br><span class="trynow-subtotal-kept">' + convertCurrency(cart.total_price) + ' if kept</span>');

    if(tryNowItemCount) {
        $(tryNowSelectors.tryNowCheckoutButton).removeClass('hidden-trynow');
        $(tryNowSelectors.tryNowHoldDisclaimer).removeClass('hidden-trynow');
        $(tryNowSelectors.tryNowLoyaltyDisclaimer).removeClass('hidden-trynow');
        $(tryNowSelectors.tryNowSubtotal).removeClass('hidden-trynow');

        $("#dynamic-checkout-cart").hide();
    } else {
        $(tryNowSelectors.tryNowCheckoutButton).addClass('hidden-trynow');
        $(tryNowSelectors.tryNowHoldDisclaimer).addClass('hidden-trynow');
        $(tryNowSelectors.tryNowLoyaltyDisclaimer).addClass('hidden-trynow');
        $(tryNowSelectors.tryNowSubtotal).addClass('hidden-trynow');
        $("#dynamic-checkout-cart").show();
    }

    enforceCartMax();
};

var enforceCartMax = function() {
    tryNowItemCount = tryNowCount(tryNowCart);

    //Enforce cart max
    if(tryNowCartMax) {
        $(tryNowSelectors.ajaxCartQtyInput).prop("disabled", true);
        $(tryNowSelectors.ajaxCartQtyTryNowPlus).prop('disabled', tryNowItemCount >= tryNowCartMax);
        $(tryNowSelectors.tryNowTrial).prop('disabled', tryNowItemCount >= tryNowCartMax);

        if(tryNowItemCount >= tryNowCartMax) {
            $(tryNowSelectors.ajaxCartQtyTryNowPlus).addClass("disabled");
            $(tryNowSelectors.tryNowTrial).addClass("disabled");
            $(tryNowSelectors.tryNowCartMaxMessage).removeClass("hidden-trynow");
        } else {
            $(tryNowSelectors.ajaxCartQtyPlus).removeClass("disabled");
            $(tryNowSelectors.tryNowTrial).removeClass("disabled");
            $(tryNowSelectors.tryNowCartMaxMessage).addClass("hidden-trynow");
        }

        if(tryNowItemCount > tryNowCartMax) {
            $(tryNowSelectors.tryNowCheckoutButton).removeAttr("href");
            $(tryNowSelectors.tryNowCheckoutButton).addClass("disabled");
        } else {
            $(tryNowSelectors.tryNowCheckoutButton).attr("href", tryNowShopUrl + tryNowCart.token);
            $(tryNowSelectors.tryNowCheckoutButton).removeClass("disabled");
        }
    }
}

$(document).ready(function() {
    //check if trynow carts are in the cart to update button url
    $.getJSON('/cart.js', function(cart) {
        tryNowCart = cart;        
        updateAjaxCart(tryNowCart);
    });

    $(tryNowSelectors.tryNowBuy).on('click', function(event) {
        $(tryNowSelectors.tryNowInput).attr('name', "");
    });

    $(tryNowSelectors.tryNowTrial).on('click', function(event) {
        // prevent button from submitting the form
        event.preventDefault();

        $(tryNowSelectors.tryNowInput).attr('name', "properties[tn_enabled]");
        $(tryNowSelectors.tryNowInput).val(true);
        const $addToCartForm = $(this).closest("form");
        const formData = new FormData($addToCartForm[0]);
        const $addToCartBtn = $(tryNowSelectors.tryNowTrial);
        Shopify.AjaxifyCart._setText($('.trynow-btn'), 'Adding...');
        $('.trynow-btn').addClass('inverted').addClass('disabled').prop('disabled', true);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function(line_item) {
                // Re-enable add to cart button.
                Shopify.AjaxifyCart._setText($('.trynow-btn'), 'Thank you!');
                Shopify.AjaxifyCart._showFeedback('success','<i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a>.',$addToCartForm);
                window.setTimeout(function(){
                    $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
                    $('#addToCart-product-template').prop('disabled', false).removeClass('disabled').removeClass('inverted');
                    Shopify.AjaxifyCart._setText($addToCartBtn, $addToCartBtn.data('label') ? $addToCartBtn.data('label') : 'Add to cart');
                    Shopify.AjaxifyCart._setText($('#addToCart-product-template'), $('#addToCart-product-template').data('label') ? $('#addToCart-product-template').data('label') : 'Add to cart');
                }, 1000);
                // Update cart count and show cart link.
                $.getJSON('/cart.js', function(cart) {
                    tryNowCart = cart;
                    if (tryNowSelectors.cartCountSelector && $(tryNowSelectors.cartCountSelector).size()) {
                        var value = $(tryNowSelectors.cartCountSelector).html() || '0';
                        $(tryNowSelectors.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
                    }
                    if (tryNowSelectors.cartTotalSelector && $(tryNowSelectors.cartTotalSelector).size()) {
                        if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
                        var newCurrency = '';
                        if ($('[name="currencies"]').size()) {
                            newCurrency = $('[name="currencies"]').val();
                        }
                        else if ($('#currencies span.selected').size()) {
                            newCurrency = $('#currencies span.selected').attr('data-currency');
                        }
                        if (newCurrency) {
                            $(tryNowSelectors.cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, "", newCurrency), Currency.money_format[newCurrency]) + '</span>');
                        } 
                        else {
                            $(tryNowSelectors.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, ""));
                        }
                        }
                        else {
                        $(tryNowSelectors.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, ""));
                        }
                    };
                });
                $(tryNowSelectors.tryNowInput).val(false);
            },
            error: function(XMLHttpRequest, textStatus) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                    response = response.description;
                if (response.slice(0,4) === 'All ') {
                    Shopify.AjaxifyCart._showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
                    $('#addToCart-product-template').prop('disabled', false);
                    Shopify.AjaxifyCart._setText($addToCartBtn, 'Sold Out');
                    Shopify.AjaxifyCart._setText($('#addToCart-product-template'), 'Sold Out');
                    $addToCartBtn.prop('disabled',true);
                }
                else {
                    Shopify.AjaxifyCart._showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
                    $addToCartBtn.prop('disabled', false).removeClass('disabled');
                    $('#addToCart-product-template').prop('disabled', false).removeClass('disabled');
                    Shopify.AjaxifyCart._setText($addToCartBtn, $addToCartBtn.data('label') ? $addToCartBtn.data('label') : 'Add to cart');
                    Shopify.AjaxifyCart._setText($('#addToCart-product-template'), $('#addToCart-product-template').data('label') ? $addToCartBtn.data('label') : 'Add to cart');
                }
                $(tryNowSelectors.tryNowInput).val(false);
            }
        });
    });   
});

function geoip(json) {
    var selectors = {
        addToCartTryNow: '#AddToCartTryNow',
        tryNowLearnMore: '#trynow-learn-more-id',
        homeBanner: '.try-now-how-it-works-section-wrapper',
    };
    
    if(json.country_code === "US") {
        $(selectors.addToCartTryNow).removeClass('hidden-not-us');
        $(selectors.tryNowLearnMore).removeClass('hidden-not-us');
        $(selectors.homeBanner).removeClass('hidden-not-us');
    } else {
        $(selectors.addToCartTryNow).addClass('hidden-not-us');
        $(selectors.tryNowLearnMore).addClass('hidden-not-us');
        $(selectors.homeBanner).addClass('hidden-not-us');
    }

    this.geo = json;
}


var fileref = document.createElement('script');
fileref.setAttribute("type","text/javascript");
fileref.setAttribute("src", "https://get.geojs.io/v1/ip/geo.js");
document.getElementsByTagName("head")[0].appendChild(fileref);


var fileref = document.createElement('script');
fileref.setAttribute("type","text/javascript");
fileref.setAttribute("src", "//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js");
document.getElementsByTagName("head")[0].appendChild(fileref);

var cssnode = document.createElement('link');
cssnode.setAttribute("type","text/css");
cssnode.setAttribute("rel", "stylesheet");
cssnode.setAttribute("src", "//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css");
document.getElementsByTagName("head")[0].appendChild(cssnode);

